import { store } from "../../store/index";
import { REGIONS } from '../../types/types';

function urlWithRegion() {
    let currentRegion = store.getState().baseReducer.region;
    let endpoint = process.env.REACT_APP_NEW_TRACKING_URL;
    if ((process.env.REACT_APP_LUMEN_ENV_VALUE !== 'release' && process.env.REACT_APP_LUMEN_ENV_VALUE !== 'alpha') || currentRegion === REGIONS.DEFAULT) {
        return endpoint
    } else {
        switch(currentRegion) {
        case REGIONS.AP:
            return endpoint.replace("tracking.", "tracking.ap.");
            break;
        case REGIONS.US:
            return endpoint.replace("tracking.", "tracking.us.");
            break;
        case REGIONS.US2:
            return endpoint.replace("tracking.", "tracking.us2.");
            break;
        case REGIONS.SA:
            return endpoint.replace("tracking.", "tracking.sa.");
            break;
        }
    }
}

export default urlWithRegion